import { ReactNode, createContext, useCallback, useContext, useState } from 'react'
import { SidebarContextProps, SidebarMeta, SidebarProviderProps } from './types'

const SidebarContext = createContext({} as SidebarContextProps)

export const SidebarProvider = ({ children }: SidebarProviderProps) => {
  const [isOpenSidebar, setIsOpenSidebar] = useState<boolean>(false)
  const [sidebarContent, setSidebarContent] = useState<ReactNode>(null)
  const [titleSidebar, setTitleSidebar] = useState('')
  const [sidebarMeta, setSidebarMeta] = useState<SidebarMeta | null>(null)

  const closeSidebar = useCallback(() => {
    setIsOpenSidebar(false)
  }, [setIsOpenSidebar])

  const openSidebar = useCallback(() => {
    setIsOpenSidebar(true)
  }, [setIsOpenSidebar])

  return (
    <SidebarContext.Provider
      value={{
        isOpenSidebar,
        sidebarContent,
        titleSidebar,
        setTitleSidebar,
        setSidebarContent,
        closeSidebar,
        openSidebar,
        sidebarMeta,
        setSidebarMeta
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

export const useSidebar = () => {
  const context = useContext(SidebarContext)

  if (!Object.keys(context).length) {
    throw new Error('Sidebar Context is not available')
  }

  return context
}
